// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/models.all.scss'

// Image boxes
async function getModelItem () {
  import(/* webpackChunkName: "modelsItem" */ './scss/components/modelsItem.scss').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
//  if ($('#go').length) {
//    const t = $('#go')
//    $('html, body').animate({
//      scrollTop: ($(t).offset().top - $('#header').height() - 50)
//    }, 300)
//  }

  // gestion des filtres depuis la navbar
  const $mn = $('#main-nav')
  const $h = $('#header')
  $h.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($h.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '999') } else { $mn.parents('.sticky-top').css('z-index', '1020') }
  })
  $mn.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($mn.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '1020') } else { $mn.parents('.sticky-top').css('z-index', '999') }
  })

  // gestion des modèles
  const $i = $('.model-item')
  if ($i.length) {
    $i.waypoint(function () {
      getModelItem()
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
